import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCallLogs } from "@/api/new-api/utility";

export const fetchCallLogs = createAsyncThunk(
  "callLog/fetchCallLogs",
  async ({ restaurantId, params }, { rejectWithValue }) => {
    try {
      const res = await getCallLogs(restaurantId, params);

      if (res.status === "success") {
        return res.data;
      }

      return rejectWithValue(res.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const initialState = {
  callLogs: [],
  pagination: null,
  statistics: null,
  getLoading: false,
  error: null,
};

const callLogSlice = createSlice({
  name: "callLog",
  initialState,
  reducers: {
    clearCallLogError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallLogs.pending, (state) => {
        state.getLoading = true;
        state.error = null;
      })
      .addCase(fetchCallLogs.fulfilled, (state, action) => {
        state.getLoading = false;
        state.callLogs = action.payload?.call_logs || [];
        state.pagination = action.payload?.pagination || null;
        state.statistics = action.payload?.statistics || null;
      })
      .addCase(fetchCallLogs.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCallLogError } = callLogSlice.actions;
export default callLogSlice.reducer;